// Module
var code = "<div>\n    <ng-wistia>\n        <ng-transclude></ng-transclude>\n    </ng-wistia>\n</div>\n";
// Exports
module.exports = code;